import { getOrderStatusIcon } from '@Utils/orderStatusIcons';

export const groupShipping = () => {
  return [
    {
      name: 'Chờ thu gom',
      id: 12,
      icon: getOrderStatusIcon('orderRequest'),
      iconActive: getOrderStatusIcon('orderRequest'),
      color: '#EB5757',
      childId: [],
      child: [],
    },
    {
      name: 'Đang chuyển',
      id: 13,
      icon: getOrderStatusIcon('shippedOut'),
      iconActive: getOrderStatusIcon('shippedOut'),
      color: '#EB5757',
      childId: [],
      child: [],
    },
    {
      id: 14,
      name: 'Giao thành công',
      icon: getOrderStatusIcon('delivered'),
      iconActive: getOrderStatusIcon('delivered'),
      color: '#EB5757',
      childId: [],
      child: [],
    },
    {
      id: 19,
      name: 'Đang hoàn',
      icon: getOrderStatusIcon('return'),
      iconActive: getOrderStatusIcon('return'),
      color: '#AF6EC3',
      childId: [],
      child: [],
    },
    {
      id: 16,
      name: 'Đã đối soát',
      icon: getOrderStatusIcon('payment'),
      iconActive: getOrderStatusIcon('payment'),
      color: '#667D8A',
      hideQuantity: true,
      childId: [],
      child: [],
    },
  ];
};
